// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1cu3O","containerItemsCenter":"Skeleton_containerItemsCenter__eDrWC"};